

























































































import { Component, Vue, PropSync, Watch, Prop } from 'vue-property-decorator'
import {
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
  BFormDatepicker,
  BSpinner
} from 'bootstrap-vue'
import { Opportunite } from '@/api/models/opportunites/opportunite'
import { errorAlert } from "@/libs/sweetAlerts/alerts"

interface OpportuniteQuickEditData {
  pourcentEtpVacation?: number
  montant?: number
  dateDecisionPrevisionnelle?: string
  niveauConfianceGain?: string
}

@Component({
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BFormDatepicker,
    BSpinner
  }
})
export default class EditOpportuniteQuickModal extends Vue {
  @PropSync('isEditModalActive', { type: Boolean, default: false })
  isModalVisible!: boolean

  @Prop({ type: String, default: '' })
  opportuniteId!: string

  @Prop({ type: String, default: '' })
  entrepriseId!: string

  opportunite: Opportunite | null = null
  isLoading = false

  niveauConfianceOptions: { value: string; text: string }[] = []

  async created() {
    await this.loadNiveauConfiance()
  }

  @Watch('isModalVisible')
  async onModalVisibilityChanged(newVal: boolean) {
    if (newVal && this.opportuniteId && this.entrepriseId) {
      await this.loadOpportunite()
    }
  }

  async loadOpportunite() {
    if (!this.opportuniteId || !this.entrepriseId) return

    this.isLoading = true
    try {
      const response = await this.$http.myressif.entreprises.getOpportuniteById(
        this.entrepriseId,
        this.opportuniteId
      )
      this.opportunite = response
    } catch (error: any) {
      console.error('Erreur lors du chargement de l\'opportunité :', error)
      errorAlert.fire({
        text: 'Une erreur est survenue lors du chargement de l\'opportunité.',
      })
      this.isModalVisible = false
    } finally {
      this.isLoading = false
    }
  }

  async loadNiveauConfiance() {
    try {
      const res = await this.$http.myressif.parametres.getByNom('opportunites_niveau_confiance')
      if (res) {
        const niveaux: { code: string; libelle: string }[] = JSON.parse(res.valeur)
        this.niveauConfianceOptions = niveaux.map(n => ({
          value: n.code,
          text: n.libelle
        }))
      }
    } catch (error) {
      console.error('Erreur lors du chargement des niveaux de confiance:', error)
    }
  }

  handleOk(event: Event) {
    event.preventDefault()
    this.$emit('save', this.opportunite)
    this.isModalVisible = false
  }

  onModalHidden() {
    this.opportunite = null
  }

  handleCancel() {
    this.$emit('cancel', this.opportuniteId)
  }
}
